import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler, IonicPageModule } from 'ionic-angular';

import { Camera } from '@ionic-native/camera';

import { LaunchReview } from '@ionic-native/launch-review';

import { CodePush } from '@ionic-native/code-push';

import { ScreenOrientation } from '@ionic-native/screen-orientation';

import { AppAvailability } from '@ionic-native/app-availability';

import { Dialogs } from '@ionic-native/dialogs';


import { MyApp } from './app.component';

import { SafePipe } from '../pipes/safe/safe';

import { SignaturePadModule } from 'angular2-signaturepad';


import { File } from '@ionic-native/file';

import { PhcMenuComponent } from '../components/phc-menu/phc-menu';
import { PhcMenuItemComponent } from '../components/phc-menu-item/phc-menu-item';
import { PhcMenuCardComponent } from '../components/phc-menu-card/phc-menu-card';
import { PhcThumbnailComponent } from '../components/phc-thumbnail/phc-thumbnail';
import { PhcArticleComponent } from '../components/phc-article/phc-article';
import { PhcInputCounterComponent } from '../components/phc-input-counter/phc-input-counter';


import { ContactPage } from '../pages/contact/contact';

import { ContentPage } from '../pages/content/content';
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { SettingsPage } from '../pages/settings/settings';
import { ReviewsPage } from '../pages/reviews/reviews';
import { InRoomDiningPage } from '../pages/in-room-dining/in-room-dining';
import { InRoomDiningOrderModal } from '../pages/in-room-dining/in-room-dining-order';
import { RoomServicePage } from '../pages/room-service/room-service';
import { RoomServiceOrderModal } from '../pages/room-service/room-service-order';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { SpinnerDialog } from "@ionic-native/spinner-dialog";
import { IonicStorageModule } from '@ionic/storage';


import { WpProvider } from '../providers/wp/wp';
import { HttpClientModule } from '@angular/common/http';
import { AppConfigProvider } from '../providers/app-config/app-config';
import { InRoomDiningServiceProvider } from '../pages/in-room-dining/in-room-dining-service';

import {ArticlePage} from "../pages/article/article";
import { AboutPage } from '../pages/about/about';
import {WebpageIframePage} from "../pages/webpage-iframe/webpage-iframe";
import { PhcLinkServiceProvider } from '../providers/phc-link-service/phc-link-service';
import { KioskServiceProvider } from '../providers/kiosk-service/kiosk-service';
import { GalleryPage } from '../pages/gallery/gallery';
import { GalleryAlbumModal } from '../pages/gallery/gallery-album-modal';
import { WeatherPage } from '../pages/weather/weather';
import { CameraPage } from '../pages/camera/camera';
import { ModuleLinkProvider } from '../providers/module-link/module-link';

import { SocialSharing } from '@ionic-native/social-sharing';
import { Device } from '@ionic-native/device';
import { FileOpener } from '@ionic-native/file-opener';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { Toast } from '@ionic-native/toast';
import { Instagram } from '@ionic-native/instagram';
import { DocumentViewer } from '@ionic-native/document-viewer';
import { WeatherProvider } from '../providers/weather/weather';
import { SubmenuPage } from '../pages/submenu/submenu';
import { AppLoadingPage } from '../pages/app-loading/app-loading';
import { PlanADayPage } from '../pages/plan-a-day/plan-a-day';
import { TabUpdateProvider } from '../providers/tab-update/tab-update.service';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { PadSelectPage } from '../pages/pad-select/pad-select';
import { WelcomeMessageComponent } from '../components/welcome-message/welcome-message';


@NgModule({
  declarations: [
    WelcomeMessageComponent,
    MyApp,
    InRoomDiningOrderModal,
    RoomServiceOrderModal,
    PhcMenuComponent,
    PhcMenuItemComponent,
    PhcMenuCardComponent,
    PhcThumbnailComponent,
    PhcArticleComponent,
    PhcInputCounterComponent,
    SafePipe,
    ContactPage,
    PadSelectPage,
    AboutPage,
    SubmenuPage,
    ContentPage,
    TabsPage,
    LoginPage,
    ArticlePage,
    PlanADayPage,
    SettingsPage,
    InRoomDiningPage,
    CameraPage,
    WeatherPage,
    GalleryPage,
    GalleryAlbumModal,
    WebpageIframePage,
    RoomServicePage,
    ReviewsPage,
    AppLoadingPage,
  ],
  imports: [
    SignaturePadModule,
    BrowserModule,
    HttpClientModule,
    IonicPageModule.forChild(ReviewsPage),
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    WelcomeMessageComponent,
    AppLoadingPage,
    ContactPage,
    PadSelectPage,
    AboutPage,
    SubmenuPage,
    ContentPage,
    TabsPage,
    LoginPage,
    ArticlePage,
    PlanADayPage,
    SettingsPage,
    InRoomDiningPage,
    CameraPage,
    WeatherPage,
    GalleryPage,
    GalleryAlbumModal,
    WebpageIframePage,
    RoomServicePage,
    ReviewsPage,
    MyApp,
    InRoomDiningOrderModal,
    RoomServiceOrderModal
  ],
  providers: [
    Camera,
    PhcLinkServiceProvider,
    StatusBar,
    SplashScreen,
    InAppBrowser,
    SpinnerDialog,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    WpProvider,
    AppConfigProvider,
    InRoomDiningServiceProvider,
    ScreenOrientation,
    CodePush,
    SafePipe,
    LaunchReview,
    KioskServiceProvider,
    ModuleLinkProvider,
    SocialSharing,
    AppAvailability,
    Device,
    DocumentViewer,
    File,
    FileOpener,
    PhotoViewer,
    Toast,
    Instagram,
    SpinnerDialog,
    WeatherProvider,
    Dialogs,
    TabUpdateProvider,
    AnalyticsProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts